<template>
  <main class="container">
    <div class="wrapper">
      <page-header class="page-header" title="You're All Done!" />

      <p>
        Good news! All tenants on this account have now signed up.
      </p>

      <p>
        We’ll email you shortly to tell you what will happen next.
      </p>

      <p>
        If you need us in the meantime, simply head
        <a href="https://www.unihomes.co.uk/contact">here</a>.
      </p>

      <p class="cancel-disclaimer">
        You'll receive an email notification within 3 business days confirming
        your Direct Debit mandate has been set up.
      </p>
    </div>
  </main>
</template>

<script>
import PageHeader from "@/components/PageHeader";

export default {
  name: "HouseComplete",
  created() {
    // We've finished the signup so reset the store data
    this.$store.dispatch("clearSession");
    // We don't need back button on this page.
    this.$store.commit("HIDE_BACK_BTN");

    this.trackGoogleEvent(
      "Final housemate completes",
      "Joining Housemate",
      "Final housemate completes",
    );
  },
  components: {
    PageHeader,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;

  @include media(">=medium") {
    max-width: 65rem;
  }
}

.wrapper {
  @include media(">=medium") {
    background-color: white;
    border-radius: $border-radius-large;
    margin-top: $spacing-large;
    padding: $spacing-medium $spacing-medium $spacing-xs $spacing-medium;
  }

  .page-header {
    margin-bottom: $spacing-medium;

    @include media(">=medium") {
      margin-top: $spacing-small;
    }
  }
}

.cancel-disclaimer {
  font-size: 1.5rem;
  color: $grey-dark;
}
</style>
